import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import '../../src/index.css';

import ChatBoxMessageListItem from './ChatBoxMessageListItem';
import Button from '@material-ui/core/Button';

export class ChatBoxMessageList extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef();
        this.state = {
            numberOfMessagesToShow: 30,
            numberOfMessagesToLoad: 30,
            scrollToBottom: this.scrollToBottom,
        };
    }

    componentDidMount() {
        this.scrollToBottom();
        //this.props.onRef(this);
        //ReactDOM.findDOMNode(this.refs.click).addEventListener('scroll', this.listenScrollEvent);
    };

    componentWillUnmount() {
        //this.props.onRef(undefined)
        //ReactDOM.findDOMNode(this.refs.click).removeEventListener('scroll', this.listenScrollEvent);
    };

    //listenScrollEvent = () => {
    //  console.log('Scroll event detected!');
    //  this.scrollToBottom();
    //}

    componentDidUpdate() {
        this.scrollToBottom();
    };

    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "instant" });
    };

    scrollToBottomDelay = () => {
        console.log("Called delay scroll");
        setTimeout(function () {
            if (this.messagesEnd !== null) {
                this.messagesEnd.scrollIntoView({ behavior: "instant" });
                this.props.callbackFromParentClick();
            }
        }.bind(this), 50);
    };

    processMessages = (messages) => {
        if (messages.length === 0) {
            return messages;
        }

        messages = messages.slice(-1 * this.state.numberOfMessagesToShow);
        messages.sort((a, b) => (a.createAt > b.createAt) ? 1 : -1);

        var currentDay = "";

        for (var i = 0; i < messages.length; i++) {
            var messageDay = new Date(messages[i].createAt).toLocaleString().split(',')[0];
            if (messageDay !== currentDay) {
                messages[i].firstMessageOfDay = true;
                currentDay = messageDay;
            }
        }
        return messages;
    };

    incrementPageSize = () => {
        this.setState({ numberOfMessagesToShow: this.state.numberOfMessagesToShow + this.state.numberOfMessagesToLoad });
    };

    render() {
        let messageButton;
        const messages = [];

        //console.log("number of messages", this.props.messages.length);
        //console.log("number of messages to show", this.state.numberOfMessagesToShow);

        if (this.props.messages.length > this.state.numberOfMessagesToShow) {
            messageButton = <Button variant="contained" /*color="primary"*/ style={{ boxShadow: "none", marginTop: '10px'}} disableFocusRipple={true} disableRipple={true} fullWidth={true} type="submit" onClick={this.incrementPageSize}>Load more messages...</Button>;
        }

        // new code
        //if (this.props.messges.length === this.state.numberOfMessagesToShow) {
        //  messageButton = <Button></Button>
        //}

        var sortedMessages = this.props.messages.sort(function (a, b) {
            return a.createAt - b.createAt;
        });

        var processedMessages = this.processMessages(sortedMessages);

        processedMessages.map((message, i) => {
            messages.push(
                <ChatBoxMessageListItem message={message} key={i} />
            );
        });

        let messageListHeight;
        if (this.props.recipient.awayMessage !== null && this.props.recipient.awayMessage !== "" && this.props.recipient.status === "Done" && this.props.recipient.inOffice === false) {
            messageListHeight = { paddingLeft: '10px', paddingRight: '10px', overflow: 'auto', position: 'absolute', top: '66px', bottom: '92px', left: '0', right: '0' };
        } else if ((this.props.recipient.awayMessage !== null && this.props.recipient.awayMessage !== "") && (this.props.recipient.awayTime !== null && this.props.recipient.awayTime !== "") && this.props.recipient.status !== "Done") {
            messageListHeight = { paddingLeft: '10px', paddingRight: '10px', overflow: 'auto', position: 'absolute', top: '47px', bottom: '92px', left: '0', right: '0' };
        } else if (this.props.recipient.status === "Done" && this.props.recipient.inOffice === false && (this.props.recipient.awayMessage === "" || this.props.recipient.awayMessage === null)) {
            messageListHeight = { paddingLeft: '10px', paddingRight: '10px', overflow: 'auto', position: 'absolute', top: '47px', bottom: '92px', left: '0', right: '0' };
        } else {
            messageListHeight = { paddingLeft: '10px', paddingRight: '10px', overflow: 'auto', position: 'absolute', top: '28px', bottom: '92px', left: '0', right: '0' };
        }

        return (
            <div style={messageListHeight}>
                {messageButton}
                <div>
                    {messages}
                </div>
                <div
                    containerid="options-holder"
                    style={{ float: "left", clear: "both" }}
                    ref={(el) => { this.messagesEnd = el; }}
                >
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        members: state.members,
        profile: state.profile,
        currentUser: state.currentUser,
    };
}

export default connect(mapStateToProps, null, null, { withRef: true })(ChatBoxMessageList);


// WEBPACK FOOTER //
// ./src/components/ChatBoxMessageList.js